<template>
  <div class="vip-box">
      <el-row>
        <el-row class="vip-bg">
          <!-- <img src="../../assets/images/banner_vip.png"> -->
          <!-- <el-row></el-row> -->
         <!--  <el-row class="discount-vip-content">
            <el-col :span="3">
              <img :src="discountVip[0].image">
              <div class="discount-vip-tag">限时特惠</div>
            </el-col>
            <el-col :span="18">
              <div class="discount-vip-title">{{ discountVip[0].title[0] + discountVip[0].title[1] + discountVip[0].title[2] }}</div>
              <div class="discount-vip-desc">有效期至2022-09-01（有效期涵盖今年整个高考季）</div>
              <div class="discount-vip-fee">
                <span class="discount-vip-fee-span1">{{ discountVip[0].present_price }}</span>
                <span>元</span>
                <span class="discount-vip-fee-span2">原价: {{ discountVip[0].price }}元</span>
              </div>
            </el-col>
            <el-col :span="3">
              <button @click="showVipHandler('2')" v-click-with-auth-login>立即购买</button>
              <el-button v-click-with-auth-login class="discount-vip-not-btn" disabled>立即购买</el-button>
            </el-col>
          </el-row> -->
          <el-row class="vip-bg-content" type="flex" justify="space-between" ref="vipCard">
            <div v-for="(item,index) in notDiscountVip" :key="index">
              <div class="vip-bg-content-left" v-if="item.type!= '3'">
                <el-row>
                  <el-col :span="6">
                    <img :src="item.image" alt="vip"/>
                  </el-col>
                  <el-col :span="18">
                    <h2 :class="item.title[1] == 'SVIP'?'vip-bg-content-left-h2':''">{{item.title[0]}}<span>{{item.title[1]}}</span>{{item.title[2]}}</h2>
                    <h3>{{item.price}}<span>元</span></h3>
                  </el-col>
                </el-row>
                <h4>会员权益：</h4>
                <div v-html="item.describe" class="vip-bg-content-desc">
                </div>
                <div>
                  <el-button @click="showVipHandler(index)" v-click-with-auth-login v-if="index == 0">立即购买</el-button>
                  <el-button @click="showVipHandler(index)" v-click-with-auth-login v-else>立即购买</el-button>
                </div>
                <!-- <div v-else-if="vipType == '1'">
                  <div class="vip-bg-content-left-desc" v-if="index == 0">您已是尊贵VIP用户，感谢信任！</div>
                  <el-button @click="showVipHandler(index)" v-click-with-auth-login v-else>升级SVIP</el-button>
                </div>
                <div v-else>
                  <div class="vip-bg-content-left-desc" v-if="index == 0">您已是尊贵VIP用户，感谢信任！</div>
                  <div class="vip-bg-content-left-desc" v-else>您已是尊贵SVIP用户，感谢信任！</div>
                </div> -->
              </div>
            </div>
          </el-row>
        </el-row>
      </el-row>
      <el-row>
        <el-row :style="{'height': 1550 + vipCarfHeight + 'px','background': '#2b2312'}">
          <el-row class="vip-table vip-infor" :style="{'padding-top': vipCarfHeight - 350 + 'px'}">
            <h3>VIP特权对比</h3>
              <el-row style="background: #ffffff;border-radius: 10px;box-shadow: 0px 8px 16px 0px rgba(44,46,51,0.10);margin-top: 40px; ">
                <el-row class="vip-table-title">
                  <el-col :span="9" class="vip-table-quanxian vip-table-item1">权限列表</el-col>
                  <el-col :span="5" class="vip-table-yidong" v-if="vipType=='中国移动高考会员'"><img src="../../assets/images/vip-icon4.png" style="position:relative;top: 12px;left: -10px;">中国移动高考会员</el-col>
                  <el-col v-else :span="5" class="vip-table-putong"><img src="../../assets/images/vip-icon1.png" style="position:relative;top: 12px;left: -10px;">普通用户</el-col>
                  <el-col :span="5" class="vip-table-huiyuan"><img src="../../assets/images/vip-icon2.png" style="position:relative;top: 12px;left: -10px;">VIP会员</el-col>
                  <el-col :span="5" class="vip-table-shuiyuan"><img src="../../assets/images/vip-icon3.png" style="position:relative;top: 12px;left: -10px;">SVIP会员</el-col>
                </el-row>
                <el-row v-for="(item,index) in compareList" :key="index" class="vip-table-content" :class="index == compareList.length-1 ? 'vip-table-content-diff1': ''">
                  <el-col :span="9" class="vip-table-item1">
                    <el-row>
                      <el-col :span="6">
                        <img :src="item.src">
                      </el-col>
                      <el-col :span="18">
                        <div class="vip-table-item1-title" :class="index == '13'?'vip-table-item1-title-diff':''">{{item.title}}</div>
                        <div class="vip-table-item1-desc">{{item.desc}}</div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" class="vip-table-item2 vip-table-item2-diff1" v-if="vipType == '中国移动高考会员'">
                    <img src="../../assets/images/duihao.png" v-if="index < 13 && index != 7">
                    <img src="../../assets/images/error.png" v-else>
                  </el-col>
                  <el-col v-else :span="5" class="vip-table-item2 vip-table-item2-diff1">
                    <img src="../../assets/images/duihao.png" v-if="index < 7">
                    <img src="../../assets/images/error.png" v-else>
                  </el-col>
                  <el-col :span="5" class="vip-table-item2 vip-table-item2-diff2">
                    <img src="../../assets/images/duihao.png" v-if="index < 13">
                    <img src="../../assets/images/error.png" v-else>
                  </el-col>
                  <el-col :span="5" class="vip-table-item2 vip-table-item2-diff3">
                    <img src="../../assets/images/duihao.png">
                  </el-col>
                </el-row>
              </el-row>
          </el-row>
        </el-row>
      </el-row>
      <el-row v-for="(item,index) in inforList" :key="index" class="vip-infor">
        <h3>{{item.title}}</h3>
        <h5>{{item.desc}}</h5>
        <img :src="item.src">
      </el-row>
      <!-- <el-row class="vip-gkbd">
          <h2>2022版高考宝典</h2>
          <h4>高考填报必用的高效工具书</h4>
          <h6>新增二本分数上一本院校推荐<br>新增专科分数上二本院校推荐<br>新增四步法教你填报适合自己的大学和专业</h6>
          <img src="../../assets/images/book.png">
      </el-row> -->
      <el-row class="vip-gj">
        <h3>360度全方位工具，助你成功升学</h3>
        <el-row class="vip-gj-center">
          <el-col :span="6" v-for="(item,index) in netList" :key="index">
            <el-row class="vip-gj-content" :class="'vip-gj-bg' + index">
              <img :src="item.src">
              <div>{{item.title}}</div>
            </el-row>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="vip-question">
        <h3>常见问题</h3>
        <el-row class="question-list" v-for="(item,index) in questionList" :key="index">
          <el-row>
            <el-col :span="1">
              <div>问</div>
            </el-col>
            <el-col :span="23">{{item.title.indexOf('荔枝生涯') !== -1 ? website.name ? item.title.replace('荔枝生涯', website.name) : '荔枝生涯' : item.title }}</el-col>
          </el-row>
          <el-row class="question-list-answer">
            <el-col :span="1">
              <div>答</div>
            </el-col>
            <el-col :span="23" v-html="item.answer.indexOf('荔枝生涯') !== -1 ? website.name ? item.answer.replace('荔枝生涯', website.name) : '荔枝生涯' : item.answer">
            </el-col>
          </el-row>
        </el-row>
      </el-row>
  </div>
</template>

<script>
import { checkVip } from '@/api/vip'
import { getProduct } from '@/api/pay'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      inforList: [
        {src: require('../../assets/images/desc1.png'),title: '权威院校、专业、招生计划数据查询',desc: '全国3000+大学和历年专业录取数据、位次、招生计划一站式查询，数据与考试院同步'},
        {src: require('../../assets/images/desc2.png'),title: '专业前景 就业趋势全面分析',desc: '智能挖掘分析3亿份就业数据，700+专业介绍，开设院校、报考热度、就业前景、行业分布、毕业去向、薪资情况全收录'},
        {src: require('../../assets/images/desc3.png'),title: '全方位测评解析 推荐适合你的专业',desc: '通过权威的性格和兴趣测评，从兴趣、性格、能力、职业倾向、学科优劣、五大维度科学定位适合你的专业方向'},
        {src: require('../../assets/images/desc4.png'),title: '多维度智能填报 选出合适的志愿',desc: '智能AI深度学习考生填报意向，根据实时数据更新算法，精准匹配个人意愿，推荐适合你的填报方案'},
        {src: require('../../assets/images/desc5.png'),title: '高考课堂',desc: '院校专业解读、政策讲解、专家分享，全方位传授志愿填报经验，教您科学选择'},
        {src: require('../../assets/images/desc6.png'),title: '高考专家实时解答报考难题',desc: '招生政策、报考指南、高校动态，不会选专业、不会做填报，有问题找专家'},
        {src: require('../../assets/images/desc7.png'),title: '海量高考资料下载 你想要的应有尽有',desc: '及时更新高考志愿填报资料、高考历年真题、联考试题、模拟考试题尽可下载'},
      ],
      netList: [
        {src: require('../../assets/images/xcx.png'),title: '高考小程序'},
        {src: require('../../assets/images/ggtb.png'),title: '高考填报网站'},
        {src: require('../../assets/images/ggbd.png'),title: '高考宝典'},
        {src: require('../../assets/images/zxdy.png'),title: '专家在线答疑'},
      ],
      questionList: [
        {
          title: '如何开通会员？',
          answer: '访问荔枝生涯官网或者小程序后，登陆后，直接输入激活码激活即可使用。'
        },
        {
          title: '荔枝生涯会员是否支持多人使用?',
          answer: '在用户填写高考分数后锁定分数，因此无法支持多人使用。'
        },
        {
          title: '荔枝生涯会员购买后可退款吗?',
          answer: '荔枝生涯会员购买后不接受退款，请您熟悉各类型志愿卡相应功能后，确保是真的需要再进行购买。'
        },
        {
          title: '在电脑端购买会员后，只能在电脑端使用吗?',
          answer: '购买会员后，可在电脑端使用，也可同时在荔枝生涯小程序上使用。'
        },
        {
          title: '荔枝生涯会员是否适用于艺术类、体育类高考的考生?',
          answer: '由于艺术类及体育类高考的政策及录取规则较为特殊，目前暂不适用这两类考生。'
        },
        {
          title: '荔枝生涯会员是否支持提前批、征集志愿(补录)的考生?',
          answer: '不支持，目前支持普通批次中的非定向招生，暂不支持提前批、征集志愿等特殊批次及定向招生。'
        },
        {
          title: '购买志愿卡后，忘记账号密码了怎么办？',
          answer: '在登录页面点击“忘记密码”，输入您的手机号码并获取验证码后，按照手机收到的短信输入您的验证码。再设置您的新密码即可。'
        }
      ],
      compareList: [
        {src: require('../../assets/images/wenhua-icon.png'),title: '文化生学校查询',desc: '查询全国文化生能选择的大学'},
        {src: require('../../assets/images/yishu-icon.png'),title: '艺术生学校查询',desc: '查询全国艺术生能选择的大学'},
        {src: require('../../assets/images/gaozhi-icon.png'),title: '高职单招学校查询',desc: '查询全国高职单招大学信息'},
        {src: require('../../assets/images/zhuanye-icon.png'),title: '专业查询',desc: '全国大学专业信息全部掌握'},
        {src: require('../../assets/images/pici-icon.png'),title: '批次线查询',desc: '查询不同省份五年录取批次线'},
        {src: require('../../assets/images/weici-icon.png'),title: '位次查询',desc: '查询您的分数当年对应位次'},
        {src: require('../../assets/images/fen-icon.png'),title: '艺术分换算',desc: '不同院校文化课与艺术课成绩比例'},
        {src: require('../../assets/images/zhiyuan-icon.png'),title: '高考志愿填报',desc: '高考志愿在线模拟填报'},
        {src: require('../../assets/images/zhineng-icon.png'),title: '智能评测',desc: '根据性格特点评测适合的专业'},
        {src: require('../../assets/images/shipin-icon.png'),title: '高考视频课程',desc: '丰富高考相关课堂讲座视频'},
        {src: require('../../assets/images/zhuanjia-icon.png'),title: '专家线上答疑',desc: '专家在线对高考问题一对一讲解'},
        {src: require('../../assets/images/gkzl-icon.png'),title: '高考志愿填报资料下载',desc: '及时更新的志愿填报及招生数据'},
        {src: require('../../assets/images/zt-icon.png'),title: '历年真题资料下载',desc: '高考历年真题、联考试题、模拟考试题'},
        {src: require('../../assets/images/gh-icon.png'),title: '一对一升学规划指导',desc: '结合学生实际情况，规划适合的升学方向 （不包括一对一志愿填报）'},
        {src: require('../../assets/images/qj-icon.png'),title: '一对一强基计划指导',desc: '报考指导，院校选择'},
        {src: require('../../assets/images/pj-icon.png'),title: '一对一综合评价指导',desc: '院校分析，报考流程指导'},
        {src: require('../../assets/images/gkzd-icon.png'),title: '一对一新高考指导',desc: '新高考选科指导'},
      ],
      vipType: '',
      vipInforList: [],
      imgUrl: 'https://gaokao.zmpajx.com/',
      discountVip: [],
      notDiscountVip: [],
      vipCarfHeight: 0
      // imgUrl: process.env.VUE_APP_BASE_API,
    }
  },
  // created() {
  //   this.checkVipHandler()
  //   this.getProductHandler()
  // },
  mounted() {
    this.checkVipHandler()
    this.getProductHandler()
	},
  computed: {
    ...mapState({
        // isVipStr: state => state.user.isVipStr,
        provinceCode: state => state.user.provinceCode,
        website: state => state.user.website
    }),
	},
  watch: {
    provinceCode() {
      this.getProductHandler();
    }
  },
  methods: {
    showVipHandler(index) {
      this.$router.push({
        name: 'buy',
        params: {
          product: this.vipInforList[index]
        }
      })
    },
    checkVipHandler() {
      checkVip().then(res => {
        this.vipType = res.data.user_type_name
        const function_code = res.data.function_code;
        this.$store.commit('user/VIPTYPESTATUS',res.data.has_code);
        this.$store.commit('user/FUNCTIONCODE',function_code);
      })
    },
    getProductHandler() {
      getProduct().then(res => {
        // const vipInforList = res.data.filter(item => { return item.type != '3'})
        const vipInforList = res.data.map(item => {
          let title = []
          let tmp = ''
          if(item.title.indexOf('荔枝生涯') != -1) {
            if(this.website.name) {
              tmp = item.title.replace('荔枝生涯', this.website.name)
            }
          }
          item.title = tmp
          if(item.title.indexOf('SVIP') != -1) {
            let indexStart = item.title.indexOf('S')
            let indexEnd = item.title.indexOf('P')
            title[0] = item.title.substr(0,indexStart)
            title[1] = item.title.substr(indexStart,indexEnd - indexStart + 1)
            title[2] = item.title.substr(indexEnd+1,item.title.length-1)
            // title[2] = ''
          } else if(item.title.indexOf('VIP') != -1) {
            let indexStart = item.title.indexOf('V')
            let indexEnd = item.title.indexOf('P')
            title[0] = item.title.substr(0,indexStart)
            title[1] = item.title.substr(indexStart,indexEnd - indexStart + 1)
            title[2] = item.title.substr(indexEnd+1,item.title.length-1)
            // title[2] = ''
          }
          item.image = this.imgUrl +item.image;
          item.title = title;
          return item
        })
        // const discountVip = vipInforList.filter(item => { return item.type == '3'})
        // const notDiscountVip = vipInforList.filter(item => { return item.type != '3'})
        // this.discountVip = discountVip
        // this.notDiscountVip = notDiscountVip
        this.notDiscountVip = vipInforList
        this.vipInforList = vipInforList
        this.$nextTick(() => {
          this.vipCarfHeight = this.$refs.vipCard.$el.offsetHeight
        });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @font-face {
      font-family: 'zihun443hao';
      src: url('../../assets/fonts/zihun443hao.ttf');
  }
  @font-face {
    font-family: 'Impact';
    src: url('../../assets/fonts/Impact.ttf');
}
  @import "@/assets/css/variables.scss";
  .vip-box {
    .vip-bg {
      width: 100%;
      height: 712px;
      background: url('../../assets/images/banner_vip.png') no-repeat center;
      background-color: rgb(43, 35, 18);
      background-size: cover;
      background-origin:border-box;
      .vip-bg-content {
        width: 1197px;
        @include gflex;
        // margin-top: 40px;
        margin-top: 300px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 99;
        animation: fade_in_bottom 1.5s;
        flex-wrap: wrap;
        .vip-bg-content-left {
          width: 580px;
          height: 406px;
          background: rgba(255,255,255,0.90);
          border-radius: 8px;
          backdrop-filter: blur(4px);
          padding: 24px;
          box-sizing: border-box;
          margin-bottom: 16px;
          img {
            width: 149px;
            height: 94px;
            border-radius: 10px;
          }
          h2 {
            font-size: 32px;
            font-weight: 600;
            text-align: left;
            color: #332e2c;
            line-height: 46px; 
            margin: 0;
            margin-left: 36px;
            span {
              color: #FFAD1E;
            }
          }
          h3 {
            font-size: 32px;
            font-weight: 400;
            color: #ee4444;
            line-height: 39px;
            margin: 0;
            margin-left: 40px;
            font-family: 'Impact';
            margin-top: 9px;
            span {
              font-size: 18px;
              position: relative;
              left: 5px;
              top: -3px;
            }
          }
          h4 {
            font-size: 18px;
            font-weight: 600;
            color: #66605e;
            line-height: 25px;
            margin: 20px 0 10px 0;
          }
          .vip-bg-content-desc {
            font-size: 14px!important;
            font-weight: 400!important;
            color: #66605e!important;
            line-height: 24px!important;
            margin: 0 auto!important;
          }
          .vip-bg-content-left-desc {
            width: 330px;
            height: 49px;
            border-radius: 8px;
            background: rgba(255,101,36,0.10)!important;
            font-size: 18px!important;
            color: $common-color!important;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 24px;
            text-align: center;
            line-height: 49px;
          }
          button {
            width: 136px;
            height: 49px;
            background: rgba(255,101,36,0.10)!important;
            border: 1px solid $common-color!important;
            border-radius: 8px;
            font-size: 18px!important;
            color: $common-color!important;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 24px;
          }
          button:hover {
            background: rgba(255,101,36,0)!important;
          }
        }
        .vip-bg-content-left-h2 {
          span {
            color: #7F16A7;
          }
        }
      }
    }
    .vip-infor {
      text-align: center;
      padding-top: 72px;
      h3 {
        font-size: 32px;
        font-weight: 600;
        margin: 0;
        color: #2c2e33;
      }
      h5 {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #909399;
        margin: 20px 0 37px 0;
      }
      img {
        width: 984px;
        margin-bottom: -3px;
      }
    }
    .vip-infor:nth-child(2n) {
      background: #ffffff;
    }
    .vip-infor:nth-of-type(3) {
      padding-top: 60px;
      position: relative;
      top: -2px;
      h5 {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #909399;
        margin-bottom: 49px;
      }
    }
    // .vip-gkbd {
    //   background: url('../../assets/images/gkbd.jpg') no-repeat center;
    //   width: 100%;
    //   height: 567px;
    //   background-size: cover;
    //   position: relative;
    //   padding-left: calc(50% - 500px);
    //   box-sizing: border-box;
    //   h2 {
    //     font-size: 48px;
    //     font-weight: 600;
    //     color: #ffbc64;
    //     margin-top: 170px;
    //     margin-bottom: 0px;
    //   }
    //   h4 {
    //     font-size: 32px;
    //     color: #ffffff;
    //     font-weight: 600;
    //     margin-top: 10px;
    //   }
    //   h6 {
    //     font-size: 16px;
    //     font-weight: 400;
    //     color: #ffffff;
    //     margin-top: 80px;
    //     line-height: 20px;
    //   }
    //   img {
    //     width: 406px;
    //     position: absolute;
    //     right: calc(50% - 514px);
    //     top: 0;
    //   }
    // }
    .vip-gj-center {
      @include gwidth;
    }
    .vip-gj {
      height: 431px;
      background: #434a62;
      text-align: center;
      h3 {
        color: #ffffff;
        font-size: 32px;
        font-weight: 600;
        margin: 72px 0;
      }
      .vip-gj-content {
        width: 284px;
        height: 162px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #ffffff;
        font-weight: 400;
        font-size: 24px;
        img {
          height: 72px;
          width: auto;
        }
        div {
          margin-top: 15px;
        }
      }
      .vip-gj-bg0 {
        background: #74cbff;
      }
      .vip-gj-bg1 {
        background: #ff8d57;
      }
      .vip-gj-bg2 {
        background: #60e188;
      }
      .vip-gj-bg3 {
        background: #8857ff;
      }
    }
    .vip-gj-content:not(:last-child) {
      padding-right: 16px;
    }
  }
  .vip-question {
    background: #fff5ed;
    padding-bottom: 70px;
    margin-bottom: -56px;
    h3 {
      margin: 72px 0 56px;
      font-weight: 600;
      color: #2c2e33;
      font-size: 32px;
      text-align: center;
    }
    .question-list {
      @include gwidth;
      padding: 36px;
      width: 1184px;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 16px;
      .el-col-1 {
        div {
          width: 40px;
          height: 40px;
          background: #ff8d57;
          border-radius: 8px;
          color: #ffffff;
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          line-height: 40px;
        }
      }
      .el-col-23 {
        color: #2c2e33;
        font-size: 24px;
        font-weight: 600;
        line-height: 40px;
        padding-left: 16px;
      }
      .question-list-answer {
        margin-top: 20px;
        .el-col-1 {
          div {
            background: #60e188;
          }
        }
        .el-col-23 {
          font-size: 18px;
          color: #5e6166;
          font-weight: 400;
          line-height: 30px;
        }
      }
    }
  }
  .vip-table {
    border-radius: 10px;
    width: 1192px;
    margin: 0 auto;
    // padding-top: 290px!important;
    h3 {
        color: #ffffff!important;
    }
    .vip-table-title {
      text-align: center;
      font-size: 24px;
      img {
        width: 44px;
        height: 46px;
      }
      >.el-col {
        height: 85px;
        line-height: 85px;
      }
    }
    .el-col-9 {
      width: 31.6%;
      border-right: 1px solid #e6e2e1;
      border-bottom: 1px solid #e6e2e1;
    }
    .el-col-5 {
      width: 22.8%;
      border-bottom: 1px solid #e6e2e1;
    }
    .el-col-5:not(:last-child) {
      border-right: 1px solid #e6e2e1;
    }
    >.el-col {
      height: 96px;
    }
    .vip-table-content {
      >.el-col {
        height: 96px;
      }
    }
    .vip-table-quanxian {
      font-weight: 600;
      color: #2c2e33;
      text-align: center!important;
      padding: 0!important;
      border-radius: 10px 0 0 0;
    }
    .vip-table-putong {
      background: linear-gradient(90deg,#e8ebf0 3%, #d9dce1 97%);
      color: #2c2e33;
    }
    .vip-table-yidong {
      background: linear-gradient(90deg,#e8ebf0 3%, #d9dce1 97%);
      color: #1696d4;
    }
    .vip-table-huiyuan {
      background: linear-gradient(90deg,#ffbf4c, #ffa04c);
      color: #914c03;
    }
    .vip-table-shuiyuan {
      background: linear-gradient(90deg,#e683ff 3%, #ad55ff 98%);
      border-radius: 0 10px 0 0;
      color: #200d3e;
    }
    .vip-table-item1 {
      background: #fffcfb;
      text-align: left;
      padding: 22px 30px 22px 24px;
      img {
        width: 56px;
        height: 56px;
        position: relative;
        // top: -8px;
      }
      .vip-table-item1-title {
        font-size: 18px;
        font-weight: 600;
        color: $common-color;
        line-height: 25px;
      }
      .vip-table-item1-title-diff {
        margin-top: -10px;
      }
      .vip-table-item1-desc {
        font-size: 14px;
        font-weight: 400;
        color: #999390;
        margin-top: 4px; 
        line-height: 20px;     
      }
    }
    .vip-table-item2 {
      img {
        width: 38px;
        height: 38px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .vip-table-content-diff1 {
      .el-col-9 {
        border-radius: 0 0 0 10px;
      }
      .el-col-5:last-child {
        border-radius: 0 0 10px 0;
      }
    }
    .vip-table-item2-diff1 {
      background: #f4f4f4;
    }
    .vip-table-item2-diff2 {
      background: #fff3dd;
    }
    .vip-table-item2-diff3 {
      background: #f7ecff;
    }
  }
  @keyframes fade_in_bottom {  
    0% {
      opacity: 0;
      bottom: -500px;
    }
    100% {
      opacity: 1;
      bottom: -10px;
    }
  }  
  @-webkit-keyframes fade_in_bottom { 
    0% {
      opacity: 0;
      bottom: -500px;
    }
    100% {
      opacity: 1;
      bottom: -10px;
    }
  }
  @keyframes fade_in_bottom1 {  
    0% {
      opacity: 0;
      bottom: -270px;
    }
    100% {
      opacity: 1;
      bottom: 0px;
    }
  }  
  @-webkit-keyframes fade_in_bottom1 { 
    0% {
      opacity: 0;
      bottom: -270px;
    }
    100% {
      opacity: 1;
      bottom: 0px;
    }
  }
  .discount-vip-content {
    width: 1200px;
    margin: 0 auto;
    height: 190px;
    background: linear-gradient(135deg,rgba(255,175,84,0.90), rgba(255,116,53,0.90));
    border-radius: 8px;
    backdrop-filter: blur(4px);
    margin-top: 306px;
    padding: 40px 24px;
    animation: fade_in_bottom1 1.5s;
    img {
      width: 149px;
      height: 94px;
      border-radius: 10px;
      position: relative;
      top: 14px;
    }
    .el-col-18 {
      padding-left: 30px;
    }
    .discount-vip-title {
      font-size: 32px;
      font-weight: 600;
      color: #ffffff;
      line-height: 46px;
    }
    .discount-vip-desc {
      padding: 0 8px;
      height: 24px;
      display: flex;
      align-items: center;
      background: rgba(255,255,255,0.20);
      border-radius: 4px;
      backdrop-filter: blur(4px);
      font-size: 14px;
      color: #ffffff;
      width: 355px;
      box-sizing: border-box;
      margin-top: 4px;
      letter-spacing: 0.2px;
    }
    .discount-vip-fee {
      font-size: 18px;
      color: #ffffff;
      margin-top: 10px;
    }
    .discount-vip-fee-span1 {
      font-size: 32px;
      font-family: 'Impact';
      color: #ffffff;
      margin-right: 5px;
    }
    .discount-vip-fee-span2 {
      font-size: 16px;
      text-decoration:  line-through;
      color: #ffffff;
      margin-left: 14px;
    }
    .discount-vip-tag {
      position: absolute;
      top: 0;
      left: 0;
      width: 96px;
      height: 32px;
      background: #ff4040;
      border-radius: 8px 0px 8px 0px;
      backdrop-filter: blur(4px);
      font-size: 16px;
      text-align: center;
      line-height: 32px;
      color: #ffffff;
    }
    button {
      width: 136px;
      height: 49px;
      background: rgba(255,255,255,0.10)!important;
      border: 1px solid #ffffff;
      border-radius: 8px;
      font-size: 18px !important;
      color: #ffffff !important;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      float: right;
    }
    button:hover {
      background: rgba(255,255,255,0)!important;
    }
    .discount-vip-not-btn {
      background: none !important;
      border: 1px solid #f0f2f5 !important;
      color: #c4c7cc !important;
    }
  }
</style>